<template>
    <form class="card">
        <h3>Транзакции</h3>
        <div class="inline" v-if="status == ''">
            <div class="grid">
                <div class="text-item finance">
                    <span>Сальдо на начало</span>
                    <p :class="{negative: parseFloat(data.diff_begin) < 0}">{{ data.diff_begin | finance }}</p>
                </div>
                <div class="text-item finance">
                    <span>Доход парковки</span>
                    <p>{{ data.income | finance }}</p>
                </div>
                <div class="text-item finance">
                    <span>Расход парковки</span>
                    <p>{{ data.outcome | finance }}</p>
                </div>
                <div class="text-item finance">
                    <span>Сальдо на конец</span>
                    <p :class="{negative: parseFloat(data.diff) < 0}">{{ data.diff | finance }}</p>
                </div>
            </div>
            <div class="grid">
                <div class="text-item" v-if="data.email_mercado_pago">
                    <span>Mercado Pago email</span>
                    <p>{{ data.email_mercado_pago }}</p>
                </div>
            </div>
        </div>
        <Transactions type="parking" :data="data" @updateData="updateData"></Transactions>
        <ConfirmPopup :data.sync="popup" @confirm="pay()"></ConfirmPopup>
    </form>
</template>

<script>
    import Transactions from '@/components/Transactions.vue'
    import ConfirmPopup from '@/components/ConfirmPopup.vue'

    import popups from '@/mixins/popups'

    export default {
        mixins: [popups],
        components: {
            Transactions,
            ConfirmPopup
        },
        props: ['status', 'data'],
        created () {
            this.$emit('getData')
        },
        methods: {
            updateData (data) {
                this.$emit('updateData', data)
            }
        }
    }
</script>